<template lang="html">

    <div class="side-chat">
        <ChatHeader :remoteUser="this.remoteUser" />
        <div class="side-chat-body" id="side-chat-body">
            <ChatMessage v-for="message in messages"
                :key="message.id"
                :message="message"
                :senderRole="message.sender_role"
                :userImageURL="message.userImageURL" />
        </div>
        <ChatFooter @message:new="sendMessage" @message:files="sendFiles"/>
    </div>

</template>

<script>
import ChatHeader from './ChatHeader.vue'
import ChatFooter from './ChatFooter.vue'
import ChatMessage from './ChatMessage.vue'
import UiNotification from '@/components/ui/Notification';

import { mapGetters } from 'vuex'
import { mapActions } from 'vuex'

export default {
    components: {
        ChatHeader,
        ChatFooter,
        ChatMessage,
        UiNotification
    },
    props: {
      localUser: {
        type: Object,
        default: function(){
          return {'online':true};
        }
      }
    },
    data() {
        return {
            messages: [],
            roomJoined: false,
            remoteUser: {},
        }
    },
    sockets: {
        join_room(data) {
            if(data.conversation !== undefined)
                data.conversation.forEach(msg => this.messages.push(msg))
        }
    },
    methods: {
        remoteUserDisconnect(){
          this.remoteUser = {online: false};
        },
        joinChatRoom() {
            //I. Prepare broadcast data
            let eventData = {
                event: 'user_joined',
                senderData: this.user,
                senderStatus: this.localUser,
                roomHash: this.roomHash
            }

            if (localStorage.getItem('role') == 'specialist') {
                eventData.specialist_joined_at = this.meeting.specialist_joined_at;
            }

            let socketsOnce = false;

            //II. Subscribe to receiving channel (roomHash)
            this.sockets.subscribe(this.roomHash, data => {
                switch (data.event) {
                    case 'new_message':
                        this.appendMessage(data.message);
                        this.$emit('newMessage', data.message);
                        break;

                    case 'user_joined': //user joined room event
                        if (socketsOnce === false) {
                            // Paul: need these to be called only once
                            this.remoteUser = data.sender_status;
                            this.$emit('userJoined'); 
                        } else {
                            socketsOnce = true;
                        }

                        if(
                            localStorage.getItem('role') == 'client' &&
                            (
                                this.meeting.specialist_joined_at == null ||
                                this.meeting.specialist_joined_at === undefined
                            )
                        ) {
                            //remaining tests todo - 13.03.2021
                            //this.$store.state.meeting.meeting.specialist_joined_at = data.specialist_joined_at || location.reload();
                            //TRELLO: REFRESH WHEN SPECIALIST JOINS ISSUE || STILL REQUIRES TESTS

                            // Paul update 29.05.2021
                            if (data.specialist_joined_at) {
                                this.$store.state.meeting.meeting.specialist_joined_at = data.specialist_joined_at;
                            } else {
                                // Dacă specialistul nu s-a conectat, o să facem request-ul încă o dată
                                setTimeout(() => {
                                    this.$socket.emit('join_room', eventData)
                                }, 2000);
                            }
                        }
                        break;
                    case 'status_update':
                      this.remoteUser = data.sender_status;
                      break;
                    default:
                        //untracked events
                        console.log(data)
                }
            })

            //III. Emit 'user_join' event
            this.$socket.emit('join_room', eventData);

            //IV. Set client-side roomJoined = true
            this.roomJoined = true;
            console.log('Room joined.');
        },
        appendMessage(msg) {
            this.messages.push(msg)
        },
        sendMessage(text) {
            let userImageURL = undefined

            if (localStorage.getItem('role') == 'specialist')
                //if specialist, send profile image else send default user img
                userImageURL = this.user.image_url

            let message = {
                body: text,
                sender_id: this.user.id,
                sender_role: this.user.role,
                userImageURL: userImageURL
            }

            let eventData = {
                event: 'new_message',
                message: message,
                roomHash: this.roomHash
            }

            this.appendMessage(message) //append message client-side

            this.$socket.emit('send_message', eventData) //send message to socket server
        },
        sendFiles(files) {
            let userImageURL = undefined

            if (localStorage.getItem('role') == 'specialist') //if specialist, send profile image else send default user img
                userImageURL = this.user.image_url 

                files.forEach((file) => {
                    let message = {
                        body : file,
                        sender_id: this.user.id,
                        sender_role: this.user.role,
                        userImageURL: userImageURL
                    }

                    let eventData = {
                        event: 'new_message',
                        message: message,
                        roomHash: this.roomHash
                    }

                    this.appendMessage(message) //append message client-side
                    this.$socket.emit('send_message', eventData) //send message to socket server
                });
        }
    },
    computed: {
        ...mapGetters({
            user: 'user/user',
            roomHash: 'anytimeMeeting/roomHash',
            meeting: 'anytimeMeeting/meeting'
        })
    },
    watch: {
        roomHash: { //**ALL STARTS FROM HERE -> WHEN THE USER IS APPENDED IN STATE
            handler(newVal) {
                if (newVal && newVal != undefined && newVal != '' && this.roomJoined == false) {
                    this.joinChatRoom()
                }
            },
            immediate: true // make this watch function is called when component created
        }
    }
}
</script>

<style lang="scss" scoped>
</style>